import $ from 'jquery';


/* List to Dropdown
********************************************/

if ($('.js-mobile-dropdown').length) {
	// Get the name of currently active item
	$('.js-mobile-dropdown').each(function(i, obj) {
		if ($(this).find('li').hasClass('is-selected')) {
			var SelectedName = $(this).find('.is-selected').text();
			$(this).append('<div class="c-mobile-dropdown__label"><span>' + SelectedName + '</span></div>');
		} else {
			var SelectedName = 'Go to...';
			$(this).append('<div class="c-mobile-dropdown__label"><span>' + SelectedName + '</span></div>');
		}
		//return false;
	});

	// Activate element
	$('.js-mobile-dropdown').click(function (e) {
		e.stopPropagation();
		$(this).toggleClass('is-active');
	});

	// Close it if user clicks outside
	$(document.body).click(function () {
		$('.js-mobile-dropdown').removeClass('is-active');
	});
	$('.js-mobile-dropdown ul').click(function (e) {
			e.stopPropagation();
	});

	// Check when item is clicked and update active label
	$('.js-mobile-dropdown a').click(function (e) {
		e.preventDefault();
		var $this = $(this);
		$this.closest('.js-mobile-dropdown ul').siblings().remove();
		$this.closest('.js-mobile-dropdown').append('<div class="c-mobile-dropdown__label"><span></span></div>');
		$this.closest('.js-mobile-dropdown').find('.c-mobile-dropdown__label span').text($(this).text());
		$this.parent().parent().parent().toggleClass('is-active');
	});
}
